/**
 * Catálogo comercial: os planos de acesso ao gerador.
 *
 * Três formas de cobrança:
 *
 * - **AVULSO** — compra pontual que soma cota (ex.: o miolo de teste).
 * - **UNICO** — pagamento único com cota total (sem prazo).
 * - **MENSAL** — assinatura por ciclo de 30 dias com cota renovada.
 *
 * Os valores são **sugestões** para o mercado brasileiro de planejadores
 * digitais. Ajuste tudo em um lugar só: aqui.
 */
export const TIPOS_COBRANCA = ['AVULSO', 'UNICO', 'MENSAL'];
export const ROTULO_COBRANCA = {
    AVULSO: 'por miolo',
    UNICO: 'pagamento único',
    MENSAL: 'por mês',
};
const LIMITES_TESTE = {
    miolos: 1,
    periodo: 'TOTAL',
    cadernosPorMiolo: 3,
    camadasPorMiolo: 3,
    cadernosAvancados: true,
    usoComercial: false,
    suportePrioritario: false,
    atualizacoesVitalicias: false,
};
const LIMITES_ESSENCIAL = {
    miolos: 3,
    periodo: 'TOTAL',
    cadernosPorMiolo: 2,
    camadasPorMiolo: 2,
    cadernosAvancados: false,
    usoComercial: false,
    suportePrioritario: false,
    atualizacoesVitalicias: false,
};
const LIMITES_PROFISSIONAL = {
    miolos: 20,
    periodo: 'TOTAL',
    cadernosPorMiolo: 10,
    camadasPorMiolo: 10,
    cadernosAvancados: true,
    usoComercial: false,
    suportePrioritario: false,
    atualizacoesVitalicias: false,
};
const LIMITES_VENDEDOR = {
    miolos: -1,
    periodo: 'TOTAL',
    cadernosPorMiolo: -1,
    camadasPorMiolo: -1,
    cadernosAvancados: true,
    usoComercial: true,
    suportePrioritario: false,
    atualizacoesVitalicias: false,
};
const LIMITES_VITALICIO = {
    miolos: -1,
    periodo: 'TOTAL',
    cadernosPorMiolo: -1,
    camadasPorMiolo: -1,
    cadernosAvancados: true,
    usoComercial: true,
    suportePrioritario: true,
    atualizacoesVitalicias: true,
};
function limitesMensais(miolos, comercial) {
    return {
        miolos,
        periodo: 'MES',
        cadernosPorMiolo: -1,
        camadasPorMiolo: -1,
        cadernosAvancados: true,
        usoComercial: comercial,
        suportePrioritario: miolos < 0,
        atualizacoesVitalicias: true,
    };
}
export const PLANOS = [
    /* ---------------- Entrada ---------------- */
    {
        id: 'teste',
        nome: 'Miolo de teste',
        resumo: 'Um miolo completo, para você ver a qualidade antes de decidir.',
        precoCentavos: 599,
        cobranca: 'AVULSO',
        publico: 'Quem quer experimentar sem compromisso.',
        recursos: [
            '1 miolo completo, que é 1 download, sem marca d\u2019água',
            'Todos os formatos: A4, A5 e A6',
            'Cores com teoria aplicada, temas e ornamentos',
            'Até 3 cadernos, incluindo caligrafia e partitura',
            'Imagem de fundo e quadros opcionais do dia',
            'Sem prazo de validade — use quando quiser',
        ],
        limites: LIMITES_TESTE,
    },
    {
        id: 'essencial',
        nome: 'Essencial',
        resumo: 'Para montar sua primeira agenda, sem pressa.',
        precoCentavos: 2700,
        precoDeCentavos: 4700,
        cobranca: 'UNICO',
        publico: 'Uso pessoal, uma ou duas agendas por ano.',
        recursos: [
            'Até 3 miolos — e 3 downloads: cada download consome um miolo',
            'Todos os formatos: A4, A5 e A6',
            'Até 2 cadernos por miolo',
            'Impressão em PDF pelo navegador',
        ],
        limites: LIMITES_ESSENCIAL,
    },
    {
        id: 'profissional',
        nome: 'Profissional',
        resumo: 'O kit completo para quem planeja de verdade.',
        precoCentavos: 6700,
        precoDeCentavos: 9700,
        cobranca: 'UNICO',
        destaque: true,
        selo: 'Melhor para uso pessoal',
        publico: 'Quem usa a agenda todo dia e quer todos os cadernos.',
        recursos: [
            'Até 20 miolos — e 20 downloads: cada download consome um miolo',
            'Cadernos ilimitados por miolo, incluindo os avançados',
            'Caligrafia, pauta musical, caderno de desenho com suas imagens',
            'Plano de leitura da Bíblia nos cânones evangélico e católico',
            'Até 10 camadas de imagem por miolo',
            'Quadros opcionais em cada página de dia',
        ],
        limites: LIMITES_PROFISSIONAL,
    },
    {
        id: 'vendedor',
        nome: 'Vendedor',
        resumo: 'Para revender agendas impressas e PDFs.',
        precoCentavos: 14700,
        precoDeCentavos: 19700,
        cobranca: 'UNICO',
        publico: 'Gráficas, papelarias e criadores que vendem planejadores.',
        recursos: [
            'Miolos ilimitados, sem prazo — e downloads ilimitados',
            'Licença comercial: você pode vender o que gerar',
            'Todos os cadernos e camadas de imagem',
        ],
        limites: LIMITES_VENDEDOR,
    },
    {
        id: 'vitalicio',
        nome: 'Vitalício',
        resumo: 'Pagamento único, acesso para sempre.',
        precoCentavos: 29700,
        precoDeCentavos: 39700,
        cobranca: 'UNICO',
        selo: 'Melhor custo no longo prazo',
        publico: 'Quem quer parar de se preocupar com renovação.',
        recursos: [
            'Tudo do Vendedor, para sempre — downloads ilimitados',
            'Todas as atualizações futuras incluídas',
            'Suporte prioritário por WhatsApp',
            'Novos tipos de caderno assim que saírem',
        ],
        limites: LIMITES_VITALICIO,
    },
    /* ---------------- Mensais ---------------- */
    {
        id: 'mensal-5',
        nome: 'Mensal 5',
        resumo: 'Cinco miolos por mês — um por semana.',
        precoCentavos: 2990,
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        publico: 'Quem monta uma agenda nova de vez em quando.',
        recursos: [
            '5 miolos por mês — 5 downloads (renova a cada 30 dias)',
            'Todos os cadernos e camadas de imagem',
            'Sem fidelidade: cancele quando quiser, é só não renovar',
        ],
        limites: limitesMensais(5, false),
    },
    {
        id: 'mensal-15',
        nome: 'Mensal 15',
        resumo: 'Quinze miolos por mês — bom para quem vende no Etsy e em feiras.',
        precoCentavos: 5990,
        precoDeCentavos: 7470,
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        destaque: true,
        selo: 'Mais escolhido',
        publico: 'Criadores que publicam vários modelos por mês.',
        recursos: [
            '15 miolos por mês — 15 downloads (renova a cada 30 dias)',
            'Todos os cadernos e camadas de imagem',
            'Atualizações incluídas enquanto assinar',
            'Sem fidelidade: cancele quando quiser',
        ],
        limites: limitesMensais(15, false),
    },
    {
        id: 'mensal-30',
        nome: 'Mensal 30',
        resumo: 'Trinta miolos por mês — para catálogos grandes.',
        precoCentavos: 9990,
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        publico: 'Quem precisa de variedade constante de formatos e temas.',
        recursos: [
            '30 miolos por mês — 30 downloads (renova a cada 30 dias)',
            'Todos os cadernos e camadas de imagem',
            'Atualizações incluídas enquanto assinar',
            'Sem fidelidade: cancele quando quiser',
        ],
        limites: limitesMensais(30, false),
    },
    {
        id: 'mensal-ilimitado',
        nome: 'Mensal Ilimitado',
        resumo: 'Use sem contar, com licença comercial.',
        precoCentavos: 14990,
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        publico: 'Gráficas e lojas com volume alto de pedidos.',
        recursos: [
            'Miolos ilimitados enquanto assinar — downloads ilimitados',
            'Licença comercial: pode vender o que gerar',
            'Suporte prioritário',
            'Atualizações incluídas enquanto assinar',
        ],
        limites: limitesMensais(-1, true),
    },
    /*
     * ---------------- Só documentos ----------------
     *
     * O editor de documentos vendido por si: quem só escreve (trabalho, artigo,
     * livro) não precisa de miolo de agenda, e quem quer conhecer entra pelo plano
     * gratuito — que é o mesmo acesso, sem cobrança, e cujo valor o administrador
     * troca pela cortesia nominal quando quiser.
     */
    {
        id: 'documentos',
        nome: 'Documentos',
        resumo: 'O editor de trabalhos, artigos e livros — sem os miolos de agenda.',
        precoCentavos: 2990,
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        publico: 'Quem escreve: trabalho acadêmico, artigo científico ou livro.',
        recursos: [
            'Formatação da ABNT pronta (margens, citações, referências)',
            'Trabalho acadêmico, artigo científico e livro em A4 ou A5',
            'Capa, folha de rosto, sumário, capítulos numerados, cabeçalho e número de página',
            'Impressão e PDF pelo próprio navegador, sem instalar nada',
            'Sem fidelidade: cancele quando quiser',
        ],
        limites: limitesMensais(0, false),
        editorDeDocumentos: true,
    },
    {
        id: 'documentos-conhecer',
        nome: 'Documentos — para conhecer',
        resumo: 'Acesso gratuito ao editor: escreva antes de decidir.',
        precoCentavos: 0,
        selo: 'Grátis',
        cobranca: 'MENSAL',
        diasDeCiclo: 30,
        publico: 'Quem quer experimentar o editor sem pagar nada por isso.',
        recursos: [
            'O mesmo editor do plano Documentos',
            'Trabalho, artigo e livro, com a ABNT formatada',
            'Sem cartão e sem prazo: o acesso é dado na hora',
            'Depois, se quiser continuar, é só assinar',
        ],
        limites: limitesMensais(0, false),
        editorDeDocumentos: true,
    },
];
/** O plano inclui o editor de documentos? (é a regra do acesso, num lugar só) */
export function planoIncluiDocumentos(id) {
    if (!id)
        return false;
    return Boolean(planoPorId(id)?.editorDeDocumentos);
}
export function planoPorId(id) {
    return PLANOS.find((plano) => plano.id === id);
}
/** Aplica os ajustes do administrador sobre um plano do catálogo. */
export function aplicarAjustes(plano, ajustes) {
    if (!ajustes)
        return plano;
    const limpo = (valor, atual) => valor === null ? undefined : (valor ?? atual);
    return {
        ...plano,
        nome: ajustes.nome?.trim() || plano.nome,
        resumo: ajustes.resumo?.trim() || plano.resumo,
        publico: ajustes.publico?.trim() || plano.publico,
        precoCentavos: typeof ajustes.precoCentavos === 'number' && ajustes.precoCentavos >= 0
            ? Math.round(ajustes.precoCentavos)
            : plano.precoCentavos,
        precoDeCentavos: limpo(ajustes.precoDeCentavos, plano.precoDeCentavos),
        destaque: ajustes.destaque ?? plano.destaque,
        selo: limpo(ajustes.selo, plano.selo),
        limites: { ...plano.limites, ...(ajustes.limites ?? {}) },
        recursos: Array.isArray(ajustes.recursos) && ajustes.recursos.length > 0 ? ajustes.recursos : plano.recursos,
    };
}
export const PLANO_TESTE = 'teste';
/** Planos de entrada, para destacar o teste na interface. */
export function planosDeEntrada() {
    return PLANOS.filter((plano) => plano.cobranca === 'AVULSO');
}
export function planosPermanentes() {
    return PLANOS.filter((plano) => plano.cobranca === 'UNICO');
}
export function planosMensais() {
    return PLANOS.filter((plano) => plano.cobranca === 'MENSAL');
}
/** Formata centavos no padrão brasileiro: 599 → "R$ 5,99". */
export function formatarPreco(centavos) {
    return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
/** Preço com o sufixo da cobrança: "R$ 59,90/mês". */
export function precoComSufixo(plano) {
    if (plano.cobranca === 'MENSAL')
        return `${formatarPreco(plano.precoCentavos)}/mês`;
    if (plano.cobranca === 'AVULSO')
        return formatarPreco(plano.precoCentavos);
    return formatarPreco(plano.precoCentavos);
}
/** Custo por miolo, para mostrar o ganho de escala. */
export function precoPorMiolo(plano) {
    if (plano.limites.miolos <= 0)
        return null;
    const porMiolo = Math.round(plano.precoCentavos / plano.limites.miolos);
    return `${formatarPreco(porMiolo)} por miolo`;
}
export function formatarLimite(valor) {
    return valor < 0 ? 'ilimitado' : String(valor);
}
/**
 * A regra que o site precisa dizer em letra grande: **um download é um miolo**.
 *
 * A cota do plano é contada em miolos, mas o que o cliente entende por "usar o
 * plano" é baixar o arquivo pronto. Como cada miolo gera um arquivo, os dois
 * números são o mesmo — e é isso que precisa estar escrito, senão a pessoa acha
 * que pode salvar três miolos e baixar cada um várias vezes.
 */
export const REGRA_DO_DOWNLOAD = 'Cada download consome um miolo do plano: baixou, usou. Ao chegar no limite de downloads, o plano é dado por encerrado.';
/**
 * A cota dita em **downloads**, que é como o cliente conta.
 *
 * O plano que não tem miolo de agenda (o pacote só de documentos) devolve texto
 * próprio: dizer "0 downloads" numa vitrine de documento acadêmico só confunde.
 */
export function descreverDownloads(plano) {
    const miolos = plano.limites.miolos;
    if (miolos === 0)
        return 'sem miolos de agenda';
    if (miolos < 0)
        return 'downloads ilimitados';
    if (miolos === 1)
        return '1 miolo · 1 download';
    return `${miolos} miolos · ${miolos} downloads`;
}
/** Descrição curta da cota, já considerando o ciclo. */
export function descreverCota(plano) {
    if (plano.limites.miolos < 0) {
        return plano.limites.periodo === 'MES' ? 'miolos ilimitados por mês' : 'miolos ilimitados';
    }
    if (plano.limites.miolos === 1)
        return '1 miolo';
    return plano.limites.periodo === 'MES'
        ? `${plano.limites.miolos} miolos por mês`
        : `${plano.limites.miolos} miolos no total`;
}
/** Converte um plano no item de checkout do provedor de pagamento. */
export function itemDoPlano(plano) {
    const sufixo = plano.cobranca === 'MENSAL' ? ` — mensal (${plano.diasDeCiclo ?? 30} dias)` : ' — acesso';
    return {
        quantity: 1,
        price: plano.precoCentavos,
        description: `${plano.nome}${sufixo} · miolos de papelaria personalizada`,
    };
}
/** Verifica se ainda cabe dentro do limite. -1 = ilimitado. */
export function dentroDoLimite(limite, quantidadeAtual) {
    return limite < 0 || quantidadeAtual < limite;
}
export function liberaRecurso(plano, recurso) {
    const valor = plano.limites[recurso];
    return typeof valor === 'boolean' ? valor : valor !== 0;
}
/**
 * Data de validade de um ciclo mensal.
 *
 * Renovando antes do vencimento, os dias restantes são somados — o cliente não
 * perde o que já pagou.
 */
export function calcularExpiracao(opcoes) {
    if (opcoes.cobranca !== 'MENSAL')
        return null;
    const agora = opcoes.agora ?? new Date();
    const base = opcoes.expiraEmAtual && opcoes.expiraEmAtual.getTime() > agora.getTime() ? opcoes.expiraEmAtual : agora;
    const dias = opcoes.diasDeCiclo ?? 30;
    return new Date(base.getTime() + dias * 86400000);
}
/** Dias restantes do ciclo, arredondados para cima. Zero = vencido. */
export function diasRestantes(expiraEm) {
    if (!expiraEm)
        return 0;
    const data = typeof expiraEm === 'string' ? new Date(expiraEm) : expiraEm;
    const diferenca = data.getTime() - Date.now();
    return diferenca <= 0 ? 0 : Math.ceil(diferenca / 86400000);
}
//# sourceMappingURL=planos.js.map